angular.module('am4').filter('errorCodeConvert', function() {

    // Converts decimal to hexadecimal and ensures string length of at least 4
    return function(error_code) {
        let _code = +error_code;
        return pad(_code.toString(16), 4).toUpperCase();
    };

    // Takes string `s` and pads the number with zeros up to length `width`
    // example:
    // pad(13, 4) === '0013'
    function pad(s, width) {
        return s.length >= width ? s : new Array(width - s.length + 1).join('0') + s;
    }
});



// WEBPACK FOOTER //
// ./src/app/filters/errorCodeConvert.js